/**************************************************
 * Nombre:       Formacion_Plan_Estudios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import Tarjeta_Plan_Estudios from "../../Tarjetas/Tarjeta_Plan_Estudios";

const Formacion_Plan_Estudios = ({item}) => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{fontSize: sCell ? 40 : 62, fontFamily: NEGRITA, fontWeight: 400}}>Plan de
                            estudios</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{fontSize: 18, fontWeight: 400, textAlign: 'center', lineHeight: 1.3}}>
                            Programas prácticos diseñados para una empleabilidad rápida en sectores clave como
                            tecnología, administración, salud e industrialave como tecnología, administración, salud e
                            industria
                        </Typography>
                    </Grid>


                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                        sx={{mt: 10}}
                    >

                        {item && item.planes && item.planes.map((it, index) => (
                            <Grid key={index + 'e89'} container size={{xs: 12, sm: 12, md: 4}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Plan_Estudios item={it}/>
                            </Grid>
                        ))}

                    </Grid>


                </Grid>


            </Grid>


        </Grid>
    )

}
export default Formacion_Plan_Estudios

const items = [1, 2]